<div class="wrap">
  <h2>Choisissez vos profils</h2>
  <div id="choice_persona">
    <mat-accordion>
      <ng-container *ngFor="let l of listLabel, let i = index">
        <app-label-persona [items]="l.items" [name]="l.name" [listProfilUser]="listProfilUser" [index]="i"
          style=" margin-bottom: 15px;"></app-label-persona>
      </ng-container>
    </mat-accordion>
  </div>
  <div class="btn_action">
    <!-- <button class="no" [routerLink]="['/home']" routerLinkActive="router-link-active"
      (click)='redirection()'>Annuler</button> -->
    <!-- <button type="submit" [routerLink]="['/home']" routerLinkActive="router-link-active">Confirmer</button> -->
    <button type="submit" (click)="redirection()">Confirmer</button>
  </div>
</div>